
  const audit = {
    path: "/audit/revisions",
    name: "dbRevisions",
    component: () => import(/* webpackChunkName: "db-revisions" */ "@/components/audit/DbRevisions.vue"),
    meta: { authorize: ['Administrator', 'Manager'], requiresAuth: true }
  };

export default audit;
    